<template>

    <div class="content-load">

        <Top></Top>

        <div class="dashboard-container">

            <!-- <Sidebar></Sidebar> -->

            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" style="margin: 0 auto;" v-if="detalhes">

                    <div class="hidden-xs">    
                        <center>
                            <img src="static/config/logo.png" class="logo-inicio">
                        </center>
                    </div>      

                    <div class="dashboard-headline hidden-xs" style="text-align: left;">
                        <h3 class="">
                            {{detalhes.nome}}
                        </h3>
                    </div>

                    <!-- Row -->
                    <div class="row margin-bottom-20">
                  
                        <div class="col-xl-12" style="text-align: left;">

                            <nav id="breadcrumbs" style="position: static; transform: none;" class="">
                                <ul>
                                    <li class="click" v-for="(item, index) in detalhes.etapas" v-bind:class="{'active': item.ordem-1 == etapa, 'disabled': !form.demo}" >
                                        <a v-on:click="setEtapa(item.ordem -1)">{{item.nome}}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>     
                    </div>
                    <iframe v-if="detalhes.status < 2" :src="'static/form.html?cod=' + detalhes.cod + '&t=' + Math.random()" style="width: 100%; border: none !important;"></iframe>
                    <div v-if="detalhes.status == 2" class="row">
                        <div class="col-xl-12">
                            <h2>
                                <i class="las la-check-circle"></i> Formulário concluído
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Formulario',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        }   
    },    
    data () {
        var self                    = this;
        return {
            "etapa":                0,
            "detalhes":             false,
            "form": {
            }              
        }
    },
    methods: {
        setEtapa: function(etapa) {
            var self = this;


            $(".dashboard-content-inner")[0].scrollTo({
                top: 0
            });    

            self.etapa = etapa;
            self.$forceUpdate();
            if (self.detalhes.etapas[etapa]) {
                self.setForm();
            } else {
            }
        },
        getFormulario: function() {
            var self        = this;
            console.log("getFormulario()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/formularios.php", {
                    params: {
                        "cod": self.form.formularioCod,
                    }, 
                    authentication: true
                })
                .then(response => {
                    
                    console.log("getFormulario() response", response);
                    self.detalhes   = response.data.result; 
                    self.etapa      = 0;
                    self.$forceUpdate();
                    loading.hide();
                    setTimeout(function() {
                        self.setForm();
                    }, 100);
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getFormulario() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        getRegistro: function() {
            var self        = this;
            console.log("getRegistro()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/formularios.php", {
                    params: {
                        "cod":      self.form.cod,
                        "tipo":     "registro"
                    }, 
                    authentication: true
                })
                .then(response => {
                    
                    console.log("getRegistro() response", response);
                    self.detalhes   = response.data.result; 
                    self.etapa      = parseInt(self.detalhes.etapa) -1;
                    self.$forceUpdate();
                    loading.hide();
                    setTimeout(function() {
                        self.setForm();
                    }, 100);
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getRegistro() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },         
        setForm: function() {
            var self = this;
            console.log("setForm()", self.detalhes);
            if (!window.__parent) return false;
            window.__parent.postMessage({
                "nome":             "setForm",
                "etapa":            self.detalhes.etapas[self.etapa],
                "queryResultado":   self.detalhes.queryResultado,
            }, "*");   
        },
        submit: function(form) {
            console.log("submit()", form)
            var self = this;
            // console.log("FORM:", form);
            if (self.form.demo) {
                alert("Você está em modo de demonstração, não é possível salvar formulários.");
                return false;
            }
            // return false;
            loading.show();

            axios.post("api/formularios.php", {
                "registroCod":  self.form.cod, 
                "dados":        form,
                "etapaCod":     self.detalhes.etapas[self.etapa].cod,
                "etapa":        parseInt(self.etapa)+1
            }, {authentication: true})
            .then(response => {
                
                console.log("submit() response", response)
                loading.hide();
                if (self.detalhes.etapas[self.etapa].mensagemSucesso) {
                    alert(self.detalhes.etapas[self.etapa].mensagemSucesso);
                } 
                
                if (self.detalhes.etapas[self.etapa].proximaEtapaRedirecionamento) {
                    self.setEtapa(parseInt(self.etapa)+1);
                } else if (self.detalhes.etapas[self.etapa].linkRedirecionamento) {
                    if (window.cordova && self.detalhes.etapas[self.etapa].linkRedirecionamento.indexOf("http://") != -1 && self.detalhes.etapas[self.etapa].linkRedirecionamento.indexOf("https://") != -1) {
                        window.open(self.detalhes.etapas[self.etapa].linkRedirecionamento, "_system");
                        self.$root.go("PendentesFormularios", JSON.stringify({"clear": 1}));
                        return false;
                    }
                    location.href = self.detalhes.etapas[self.etapa].linkRedirecionamento;
                } else {
                    self.$root.go("PendentesFormularios", JSON.stringify({"clear": 1}));
                }
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        init: function() {
            var self = this;
            if (!self.$route.query.c && !self.$route.query.formularioCod) {
                self.$root.back();
                return false;
            }
            loading.show();

            if (self.$route.query.demo) {
                self.form.demo = true;
            }

            if (self.$route.query.c) {
                self.form.cod = self.$route.query.c;
                self.getRegistro();
            } else if (self.$route.query.formularioCod) {
                self.form.formularioCod = self.$route.query.formularioCod;
                self.getFormulario();                
            }
            self.$forceUpdate();


            var eventMethod     = window.addEventListener ? "addEventListener" : "attachEvent";
            self.messageEvent   = eventMethod === "attachEvent" ? "onmessage" : "message";
            window._onMessage   = function (e) {
            
                console.log("on message >", e);

                if (typeof e.data != "string") {
                    if (e.data.nome == "init") {
                        window.__parent =  event.source;

                        self.setForm();           
                    }
                    if (e.data.nome == "setHeight") {
                        if (self.$root.mobile.isMobile) {
                            $("iframe").css("height", e.data.height + "px")
                        } else {
                            $("iframe").css("height", e.data.height + 100 + "px")
                        }
                    }

                    if (e.data.nome == "submit") {
                        self.submit(e.data.form)
                    }
                }
            }
            window.removeEventListener("onmessage", window._onMessage, false);
            window.removeEventListener("message", window._onMessage, false);                

            var eventer     = window[eventMethod];
            eventer(self.messageEvent, window._onMessage);                  

        }
    },
    created: function() {
        console.log("created form>");
        var self = this;
        self.init();
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #breadcrumbs ul li a {
        font-size: 16px;
    }
    #breadcrumbs ul li.active {
        pointer-events: none !important;
        opacity: 0.5;
    }
    @media only screen and (max-width: 500px) { 
        #breadcrumbs ul li {
            width: 100%;
            padding-top: 2px;
            padding-bottom: 2px;
        }
    }

    .content-load, .dashboard-container, .dashboard-content-inner, .dashboard-content-container  {
        background: #fff !important;
    }

    .disabled {
        pointer-events: none !important;
/*        opacity: 0.6 !important;*/
    }

    #breadcrumbs ul li:before {
        content: "";
        display: inline-block;
        height: 0;
        width: 0;
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
        border-left: 4px solid #aaa;
        font-size: 14px;
        margin-right: 12px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Formulario.vue